import { useState } from "react";
import { useClickOutSide } from "../../../hooks/useClickOutside";
import styles from "./styles.module.scss";
import primaryComponents from "../../primaryComponents";
import { OptionAltIcon } from "../../../assets/svgIcons";

export const MoreDropDown = ({ children, btnStyles = {} }) => {
  const [isOpen, setIsOpen] = useState(false);

  const { inputRef } = useClickOutSide({ close: () => setIsOpen(false) });

  return (
    <span className={`${styles.moreDropDown}`} ref={inputRef}>
      <primaryComponents.Button
        classNames={"btn btn--outline"}
        style={{
          width: "48px",
          height: "48px",
          padding: "0",
          borderColor: "black",
          ...btnStyles,
        }}
        onClick={() => setIsOpen(!isOpen)}
      >
        <OptionAltIcon style={{ fontSize: "20px" }} className="dark--text" />
      </primaryComponents.Button>

      {isOpen ? <span className={styles.dropdrown}>{children}</span> : null}
    </span>
  );
};
